import React, { useEffect } from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { CenteredLoadingIndicator } from "#/components/views/molecules/Molecules"
import { useSprintsCandidacyQuery } from "#/services/user/hooks/useSprintsQuery"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import { Journey } from "#/components/carrot-plans/types/journey"

export default function DoAnyApplyCheckInDecisionStep(): JSX.Element {
  const routingData = useCheckRoutingInfoQueryCache()
  const journey = routingData?.journey
  const sprintsCandidacyQuery = useSprintsCandidacyQuery()
  const memberIsSprintsCandidate = sprintsCandidacyQuery.data?.memberIsSprintsCandidate ?? false
  const partnerIsSprintsCandidate = sprintsCandidacyQuery.data?.partnerIsSprintsCandidate ?? false

  const { send } = useStateMachine()
  useEffect(() => {
    if (!sprintsCandidacyQuery.isFetching) {
      if (journey === Journey.PREGNANT || memberIsSprintsCandidate) {
        send("DO_ANY_APPLY")
      } else if (partnerIsSprintsCandidate) {
        send("PARTNER_DO_ANY_APPLY")
      } else {
        send("")
      }
    }
  }, [sprintsCandidacyQuery.isFetching, send, memberIsSprintsCandidate, partnerIsSprintsCandidate, journey])

  return <CenteredLoadingIndicator />
}
